module.exports = __webpack_public_path__ + "img/selected5-min.49e760a4.png";